import { Directive, Input } from '@angular/core';

@Directive({ selector: '[required]' })
export class RequiredDirective {
    @Input() required: string | boolean;
}
